import { render, staticRenderFns } from "./SearchBlockedInflection.vue?vue&type=template&id=09fd2c8e&lang=html"
import script from "./SearchBlockedInflection.vue?vue&type=script&lang=js"
export * from "./SearchBlockedInflection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports